export const state = () => ({
  notifications: [],
})

export const getters = {
  notifications: state => state.notifications,
}

export const actions = {
  resetNotification({ commit }) {
    commit('RESET_NOTIFICATIONS')
  },
  deleteNotification({ commit }, index) {
    commit('DELETE_NOTIFICATIONS', index)
  },
  setNotifications({ commit }, notifications) {
    commit('ADD_NOTIFICATIONS', notifications)
  },
}

export const mutations = {
  RESET_NOTIFICATIONS(state) {
    state.notifications = []
  },
  ADD_NOTIFICATIONS(state, notifications) {
    const newNotifications = state.notifications.concat(notifications)
    state.notifications = newNotifications
  },
  DELETE_NOTIFICATIONS(state, index) {
    state.notifications.splice(index, 1)
    const newNotifications = []
    state.notifications = newNotifications.concat(state.notifications)
  },
}
